/**
 * The request header an external study page sends so the core-api proxy uses
 * that project's external session. Its own module so the browser can import
 * it without the server-only session code.
 */
export const EXTERNAL_PROJECT_HEADER = 'x-respondent-external-project';
